type MetaEventPayload = Record<string, string | number | boolean | null | undefined>;

type MetaTrackMethod = "track" | "trackCustom";

const isFbqAvailable = () =>
  typeof window !== "undefined" && typeof window.fbq === "function";

const dispatchMetaEvent = (
  method: MetaTrackMethod,
  eventName: string,
  payload?: MetaEventPayload,
) => {
  if (!isFbqAvailable()) return;
  const fbq = window.fbq;
  if (!fbq) return;
  if (payload && Object.keys(payload).length > 0) {
    fbq(method, eventName, payload);
    return;
  }
  fbq(method, eventName);
};

export const trackMetaStandardEvent = (
  eventName: string,
  payload?: MetaEventPayload,
) => {
  dispatchMetaEvent("track", eventName, payload);
};

export const trackMetaCustomEvent = (
  eventName: string,
  payload?: MetaEventPayload,
) => {
  dispatchMetaEvent("trackCustom", eventName, payload);
};
